var RewardErrorCodes;
(function (RewardErrorCodes) {
    // Rewards
    RewardErrorCodes["OrderInput"] = "PBREWOrderInput";
    RewardErrorCodes["OrderNotFound"] = "PBREWOrderNotFound";
    RewardErrorCodes["OrderCreate"] = "PBREWOrderCreate";
    RewardErrorCodes["OrderInvalidInput"] = "PBREWOrderInvalidInput";
    RewardErrorCodes["OrderSnapshot"] = "PBREWOrderSnapshot";
    RewardErrorCodes["RewardPayment"] = "PBREWPayment";
    // Rewards saga
    RewardErrorCodes["InsufficientStock"] = "PBRSSInsufficientStock";
    RewardErrorCodes["InvalidJSON"] = "PBRSSInvalidJSON";
    RewardErrorCodes["InvalidArgument"] = "PBRSSInvalidArgument";
    // Rewards catalogue
    RewardErrorCodes["RewardInput"] = "PBRCARewardInput";
    RewardErrorCodes["RewardNotFound"] = "PBRCARewardNotFound";
    RewardErrorCodes["RewardFilters"] = "PBRCARewardFilters";
    RewardErrorCodes["RewardURLSlugExists"] = "PBRCARewardURLSlugExists";
    RewardErrorCodes["RewardInternalIdentifierExists"] = "PBRCARewardInternalIdentifierExists";
    RewardErrorCodes["NotAllowed"] = "PBRCANotAllowed";
})(RewardErrorCodes || (RewardErrorCodes = {}));
export default RewardErrorCodes;
